// Э-2. Проекты: карточки проектов и объектов — текущий этаж из всех, статус, отставание, проблемы.

import { fmtDate } from "../../shared/format";
import { useLive } from "../../shared/live";
import { navigate } from "../../shared/router";
import { TopBar } from "../../shared/shell";
import { InstallButton } from "../../shared/install";
import { Bar, Button, Empty, Loading, useAsync } from "../../shared/ui";
import { api, can, floorName, isStage, live, useCtx } from "../ctx";
import { PendingPanel, StateTag } from "../lifecycle";


export function ProjectsPage() {
  const { me, setBuilding, buildingId } = useCtx();
  const p = useAsync<any[]>(() => api.get("/projects"), []);
  useLive(live, ["report.", "cycle.", "issue.", "building."], () => p.reload(), 1500);
  const open = (id: string) => { setBuilding(id); navigate(`/b/${id}`); };
  return (
    <>
      <TopBar title="Проекты"><InstallButton name="Приложение «Стройка»" />{can(me, "admin.projects") && <Button onClick={() => navigate("/admin")}>Новый проект или корпус</Button>}</TopBar>
      <div className="content">
        {(can(me, "projects.approve") || can(me, "admin.projects")) && <PendingPanel onChanged={p.reload} />}
        {!buildingId && p.data && p.data.some((x) => x.buildings.length > 0) && (
          <div className="alert info"><div className="t">Выберите корпус, с которым будете работать</div>
            <div className="d">Нажмите на карточку корпуса — система запомнит выбор, и в следующий раз он откроется сразу.</div></div>
        )}
        {!p.data ? <Loading error={p.error} onRetry={p.reload} /> : p.data.length === 0 ? (
          <Empty>Вас пока не назначили ни в один проект. Обратитесь к администратору.</Empty>
        ) : p.data.map((proj) => (
          <section key={proj.id} className="stack">
            <div className="row between">
              <div>
                <h2>{proj.name} <StateTag state={proj.state} /></h2>
                <p className="muted small">{[proj.address, proj.legal_entity].filter(Boolean).join("; ")}{proj.role ? ` — вы ${proj.role.toLowerCase()}` : ""}</p>
              </div>
            </div>
            {proj.buildings.length === 0 && <p className="muted">Корпусов нет. Администратор создаёт корпус мастером: этажи, шаблон цикла, дата старта.</p>}
            <div className="cols-3">
              {proj.buildings.map((b: any) => (
                <button key={b.id} className="panel pad stack tight" style={{ textAlign: "left", cursor: "pointer" }} onClick={() => open(b.id)}>
                  <div className="row between"><h3>{b.name}</h3>
                    {b.effective_state && b.effective_state !== "active" ? <StateTag state={b.effective_state} /> : <span className={`tag ${b.finished ? "s-done" : b.status === "behind" ? "s-loading" : b.status === "ahead" ? "s-done" : "s-planned"}`}>
                      {b.finished ? "завершён" : b.cycles_done === 0 && b.status === "on_plan" && b.lag_days === 0 && new Date(b.start_date) > new Date() ? `старт ${fmtDate(b.start_date)}` : b.status === "behind" ? `отставание ${b.lag_days} дн.` : b.status === "ahead" ? "опережение" : "по плану"}
                    </span>}
                  </div>
                  {isStage(b.current_floor)
                    ? <div style={{ fontSize: 22, fontWeight: 700 }}>{floorName(b.current_floor)}</div>
                    : <div style={{ fontSize: 30, fontWeight: 700 }} className="num">{b.current_floor ?? "—"} <span className="muted" style={{ fontSize: 18 }}>/ {b.floors_count} этаж</span></div>}
                  {!b.approved && can(me, "admin.projects") && <span className="small muted">ждёт согласования</span>}
                  <Bar value={b.cycles_done} max={b.cycles_total || 1} />
                  <div className="row between small muted">
                    <span>Готово циклов: {b.cycles_done} из {b.cycles_total}</span>
                    <span>{b.issues_open ? `Проблем: ${b.issues_open}` : "Проблем нет"}</span>
                  </div>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
}
